import Alert from '@mui/material/Alert'
import { SnackbarContent, useSnackbar } from 'notistack'
import { forwardRef } from 'react'

export const Notification = forwardRef(
  ({ id, message, style, variant }, ref) => {
    const { closeSnackbar } = useSnackbar()

    return (
      <SnackbarContent ref={ref} style={style}>
        <Alert
          style={style}
          severity={variant}
          onClose={() => closeSnackbar(id)}
        >
          {message}
        </Alert>
      </SnackbarContent>
    )
  },
)
